<script context="module" lang="ts">
  export enum RatingType {
    Star = 'Star',
    Love = 'Love',
  }
</script>

<script lang="ts">
  import Icon from 'src/components/Icon.svelte';

  export const RATING_CONFIG = {
    [RatingType.Star]: {
      iconName: 'eva-star',
      color: 'rating',
    },
    [RatingType.Love]: {
      iconName: 'eva-heart',
      color: 'negative',
    },
  };
  export let type: RatingType = RatingType.Star;

  export let ratingMax: number = 5;
  export let rating: number = 0;

  $: ratingBoolArr = new Array(ratingMax).fill(false).fill(true, 0, rating);
  $: ratingConfig = RATING_CONFIG[type];
</script>

<div>
  {#each ratingBoolArr as ratingBool}
    <Icon
      color={ratingBool ? ratingConfig.color : 'light-2'}
      name={ratingConfig.iconName}
    />
  {/each}
</div>
